<template>
  <div id="osList">
    <filtros-borracharia>
    </filtros-borracharia>

    <div class="table-responsive">
      <table class="table table-striped tabelaInventario">
        <thead>
          <tr>
            <th scope="col">{{ $t('ACAO')}}</th>
            <th scope="col">{{ $t('PLACA')}}</th>
            <th scope="col">{{ $t('TIPO')}}</th>
            <th scope="col">{{ $t('CONJUNTO')}}</th>
            <th scope="col">{{ $t('ULTIMA MM')}}</th>
            <th scope="col">{{ $t('PRÓXIMA MM')}}</th>
            <th scope="col">{{ $t('ULTIMA CAL')}}</th>
            <th scope="col">{{ $t('PRÓXIMA CAL')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(placa, index) in placas" :key="index" >
            <th class="d-flex" scope="row">
              <b-button class="btn btn-info m-1" v-b-modal.modalMilimetragem @click="submitPlacaModal(placa)">
                {{ $t('AFERIÇÃO')}}
              </b-button>
              <b-button v-if="placa.exibe_terminal != 'S'" class="btn btn-success m-1" v-b-modal.modalCalibragem @click="modalCalibragem(placa)">
                {{ $t('CALIBRAGEM')}}
              </b-button>
            </th>
            <td>{{ placa.nr_placa }}</td>
            <td>{{ placa.ds_tipoveiculo }}</td>
            <td>{{ placa.ds_conjunto }}</td>
            <td>{{ placa.mm ? placa.mm : $t('Nunca feito') + '!' | formatDate("DD/MM/YYYY")}}
            </td>
            <td>{{ placa.mm_previsao ? placa.mm_previsao : $t('Nunca feito') + '!' | formatDate("DD/MM/YYYY")}} <br>
              <div v-if="placa.mm">
                <span class="foraPrazo" v-if="validaDataMM(placa)">{{ $t('Fora do Prazo') }}</span>
                <span class="dentroPrazo" v-else>{{$t('Dentro do Prazo')}}</span>
              </div>
            </td>
            <td>{{ placa.calibragem ? placa.calibragem : $t('Nunca feito') + '!' | formatDate("DD/MM/YYYY")}} </td>
            <td>{{ placa.calibragem_previsao ? placa.calibragem_previsao : $t('Nunca feito') + '!' | formatDate("DD/MM/YYYY")}}<br>
              <div v-if="placa.calibragem">
                <span class="foraPrazo" v-if="validaDataCal(placa)">{{ $t('Fora do Prazo') }}</span>
                <span class="dentroPrazo" v-else>{{$t('Dentro do Prazo')}}</span>
              </div>
            </td>
          </tr>
        </tbody>  
      </table>
    </div>
    <modal-milimetragem ref="childAfericao" :nr_placa="placa"></modal-milimetragem>
    <modal-calibragem ref="childMilimetragem" :nr_placa="placa"></modal-calibragem>
  </div>
</template>

<script>
import FiltrosBorracharia from '@/components/FiltrosBorracharia'
import ModalMilimetragem from '@/components/Borracharia/ModalMilimetragem'
import ModalCalibragem from '@/components/Borracharia/ModalCalibragem'

export default {
  components: {
    FiltrosBorracharia,
    ModalMilimetragem,
    ModalCalibragem
  },

  data() {  
    return {
      placa: ''
    }
  },

  computed: {
    placas() {
      const placas = this.$store.getters['borracharia/getPlacas']

      if (!placas) {
        this.$store.dispatch('borracharia/fetchFromPlacas', {})
      }

      return placas
    },
    paginacao() {
      return this.$store.getters['os/pagination']
    },
  },

  mounted() {
    this.$store.dispatch('borracharia/fetchFromPlacas', {})
  },

  methods: {
    validaDataCal(placa) {
      if (!placa.calibragem_previsao) return placa

      const [ano, mes, dia] = placa.calibragem_previsao.split('-').map(Number)
      const data = new Date(ano, mes - 1, dia)
      const dataAtual = new Date()

      data.setHours(0, 0, 0, 0)
      dataAtual.setHours(0, 0, 0, 0)

      console.log(placa.nr_placa)
      console.log(data)
      console.log(dataAtual)
      console.log(data.getTime() <= dataAtual.getTime()) 

      return data.getTime() < dataAtual.getTime()
    }, 

    validaDataMM(placa) {
      if (!placa.mm_previsao) return placa

      const [ano, mes, dia] = placa.mm_previsao.split('-').map(Number)
      const data = new Date(ano, mes - 1, dia)
      const dataAtual = new Date()

      data.setHours(0, 0, 0, 0)
      dataAtual.setHours(0, 0, 0, 0)

      console.log(placa.nr_placa)
      console.log(data)
      console.log(dataAtual)
      console.log(data.getTime() <= dataAtual.getTime())

      return data.getTime() < dataAtual.getTime()
    },
    submitPlacaModal(placa) {
      this.placa = placa

      this.$refs.childAfericao.inverterPneu = false
      
      this.$store.dispatch('borracharia/getPlacaMilimetragem', { data: placa }).then(() => {
        this.$refs.childAfericao.gerarCaminhao()
        this.$refs.childAfericao.adicionarAcao()
        this.$refs.childAfericao.adicionarClassePneu()
      })
      // this.propsPlaca = placa
    },
    modalCalibragem(placa) {
      this.placa = placa
      this.$store.dispatch('borracharia/getPlacaMilimetragem', { data: placa }).then(() => {
        this.$refs.childMilimetragem.gerarCaminhao()
        this.$refs.childMilimetragem.adicionarAcao()
        this.$refs.childMilimetragem.adicionarClassePneu()
        
      })
    }
  }
}
</script>

<style lang="scss">
.icon--custom {
  top: 50px;
}

.foraPrazo {
  font-size: 13px;
  color: #d24d4d;
  font-weight: bold;
}
.dentroPrazo {
  font-size: 13px;
  font-weight: bold;
  color: #23b344;
}
// .backgroundWarning {

// }

.backgroundError {
  background: linear-gradient(45deg, #992d2d, #fd6565);
  color: #fff;
}

// .content {
//   padding: 0 0;
// }
// .container-fluid{
//   padding-right: 0px;
//   padding-left: 0px;
// }</style>